import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.0.7_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.0.7_react-dom@18.3.1_react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Cabin\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-cabin\",\"display\":\"swap\"}],\"variableName\":\"cabin\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@2.0.7_react-dom@18.3.1_react@18.3.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/vercel/path0/src/components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralModal"] */ "/vercel/path0/src/components/ReferralModal.tsx");
